import { render, staticRenderFns } from "./UserEditCard.vue?vue&type=template&id=5cdf11b4&"
import script from "./UserEditCard.vue?vue&type=script&lang=js&"
export * from "./UserEditCard.vue?vue&type=script&lang=js&"
import style0 from "./UserEditCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports